export const COMMAND = [
    {
        name: "Попов Максим",
        position: 'Заместитель технического директора "Акцепт"',
        mail: "m.popov@izvestia.ru",
        avatar: "/images/users/user1.jpg"
    },
    {
        name: "Максим Дудкин",
        position: "Teamlead",
        mail: "m.dutkin@izvesita.ru",
        avatar: "/images/users/user2.jpg"
    },
    {
        name: "Талызин Андрей",
        position: "Программист",
        mail: "a.talyzin@izvestia.ru",
        avatar: "/images/users/user3.jpg"
    },
    {
        name: "Пьянков Николай",
        position: "Системный администратор",
        mail: "n.pyankov@izvestia.ru",
        avatar: "/images/users/user4.jpg"
    },
    {
        name: "Десятов Илья",
        position: "Системный администратор",
        mail: "idesyatov@izvestia.ru",
        avatar: "/images/users/user5.jpg"
    },
    {
        name: "Зива Дмитрий",
        position: "Системный администратор",
        mail: "d.ziva@izvestia.ru",
        avatar: "/images/users/user6.jpeg"
    },
    {
        name: "Степанов Виталий",
        position: "Инженер",
        mail: "v.stepanov@izvestia.ru",
        avatar: "/images/users/user7.jpg"
    },
    {
        name: "Пастушенко Светлана",
        position: "UI/UX дизайнер",
        mail: "s.pastushenko@izvestia.ru",
        avatar: "/images/users/user8.jpg"
    }
];


// WEBPACK FOOTER //
// ./src/command.js